export default __webpack_public_path__ + "static/media/Etape2_ButteduBuisson_ChevalementPuits1ChampRobert.b8bc5eda.jpg";